import Button from '@jetbrains/ring-ui-built/components/button/button'
import {H2} from '@jetbrains/ring-ui-built/components/heading/heading'
import {resolveRelative} from '@jetbrains/teamcity-ui/dist/utils'

import {useDarkOrLightTheme} from '../../../hooks/theme/useDarkOrLightTheme'
import Routes from '../../../routes'

import Image404Dark from './404_dark.svg'
import Image404Light from './404_light.svg'

import styles from './PageNotFound.module.css'

type PageNotFoundProps = {
  message?: string
}

function PageNotFound({message = ''}: PageNotFoundProps) {
  const theme = useDarkOrLightTheme()
  const isDark = theme === 'dark'
  const imageSrc = isDark ? Image404Dark : Image404Light
  const hrefToFavoriteProjects = resolveRelative(`/${Routes.FAVORITE_PROJECTS}`)

  return (
    <div className={styles.main}>
      <div className={styles.body}>
        <img alt="Page Not found" src={imageSrc} width="280" height="200" />
        <H2 className={styles.title}>{'Not found'}</H2>
        <div className={styles.messageBody}>
          <span title={message} className={styles.message}>
            {message}
          </span>
          {'Check that the URL is correct'}
        </div>
        <Button href={hrefToFavoriteProjects} primary>
          {'Go to Favorite projects'}
        </Button>
      </div>
    </div>
  )
}

export default PageNotFound
